(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["address-event-popup"] && !Shopify.designMode) return;
  try {
    
  class addressEventPopup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.closePopupBtn = this.querySelectorAll(".js-close-pop");
      this.alreadyAppliedBtn = this.querySelector("#alreadyAppliedBtn");

      // 팝업표시
      this.style.setProperty("display", "grid");

      // 팝업 닫기 기능
      this.closePopupBtn.forEach((e) => {
        e.addEventListener('click', () => {
          this.style.setProperty("display", "none");
        });
      });

      // 이미 신청된 경우 알림을 띄우고 버튼 클릭 시 행동을 막음
      if (this.alreadyAppliedBtn) {
        this.alreadyAppliedBtn.addEventListener("click", function() {
          alert("You have already applied for this gift.");
        });
      }
    }

    // disconnectedCallback() {
      
    // }
  }

  customElements.define("address-event-popup", addressEventPopup);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-end-popup"] && !Shopify.designMode) return;
  try {
    
  class eventEndPopup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.closePopupBtn = this.querySelectorAll(".js-close-pop");

      // 팝업표시
      this.style.setProperty("display", "flex");

      // 팝업 닫기 기능
      this.closePopupBtn.forEach((e) => {
        e.addEventListener('click', () => {
          this.style.setProperty("display", "none");
        });
      });

    }

    // disconnectedCallback() {
      
    // }
  }

  customElements.define("event-end-popup", eventEndPopup);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-gift-promotion"] && !Shopify.designMode) return;
  try {
    

  const alreadyAppliedBtn = document.getElementById("alreadyAppliedBtn");

// 이미 신청된 경우 알림을 띄우고 버튼 클릭 시 행동을 막음
  if (this.alreadyAppliedBtn) {
    this.alreadyAppliedBtn.addEventListener("click", function() {
        alert("Your application has already been completed.\nIf you haven't saved your address, please go to 'My address' page and save it.");
    });
  }


  } catch(e) { console.error(e); }
})();
})();
